import { Fragment } from 'react';
import PropTypes from 'prop-types';

import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import { TextImage } from 'Components/TextImage';
import { Typography } from 'Components/Typography';

import { srcOrNextImageProp } from 'PropTypes/imageProps';

import useResponsiveVariant from 'utils/useResponsiveVariant';

const ColumnContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
`;

const SectionTitle = styled(Typography)`
  font-weight: 500;
  font-size: 16px;
  margin-right: 50px;
  min-width: 83px;
  width: 83px;
  text-align: left;
`;

const Title = styled(Typography)`
  margin-bottom: 18px;
`;

const Spacer = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${theme.colors.neutral[700]};
  margin: 36px 0px;
`;

const ProductVariantHero = ({ content }) => {
  const { isDesktop } = useResponsiveVariant();
  return (
    <TextImage
      contentAlignMob="left"
      imageDesktop={content.images.desktop}
      imageMobile={content.images.mobile}
      imageMode="cover"
      wideScreenOrder={isDesktop ? content.wideScreenOrder : undefined}
    >
      <Title variant="h1">{content.title}</Title>
      <Typography color="grey" variant="mono1">
        {content.subtitle}
      </Typography>
      <Spacer />
      {content.descriptions.map(({ title, descriptions }, index) => (
        <Fragment key={title}>
          <ColumnContainer>
            <SectionTitle variant="mono1">{title}</SectionTitle>
            <div>
              {descriptions.map(description => (
                <Typography key={description} align="left" color="noir" variant="p1">
                  {description}
                  <br />
                </Typography>
              ))}
            </div>
          </ColumnContainer>
          {index + 1 !== content.descriptions.length && <Spacer />}
        </Fragment>
      ))}
    </TextImage>
  );
};

ProductVariantHero.propTypes = {
  content: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    descriptions: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        descriptions: PropTypes.arrayOf(PropTypes.string),
      })
    ).isRequired,
    wideScreenOrder: PropTypes.string.isRequired,
    images: PropTypes.shape({
      mobile: srcOrNextImageProp,
      desktop: srcOrNextImageProp,
      alt: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default ProductVariantHero;
